/* @flow */
import * as React from 'react';

import UserActionsMenuButton from 'user/components/UserActionsMenuButton';
import mapGraphQLMemberToUserActionsMenuButtonUser from 'user/lib/mapGraphQLMemberToUserActionsMenuButtonUser';

import type { UserProfile } from 'users/components/UsersProfile';

export type Props = {
  organization: {
    +id: number,
    +uuid: string,
    +name: string,
  },
  member: UserProfile,
  onUserRemoved: () => void,
  onUserUpdate: () => void,
  onGetTranscript: boolean => void,
};

export default function OrganizationMemberActionsMenuButton(props: Props) {
  const { organization, member, onUserRemoved, onUserUpdate, onGetTranscript } = props;
  const { userInteractionPermissions } = member;
  const {
    canBlock,
    canChangeRole,
    canCopyToAnotherGroup,
    canRemoveFromGroup,
    canReportToRemind,
  } = userInteractionPermissions;

  return (
    <UserActionsMenuButton
      buttonSize="xsmall"
      copyToClassText="Add to a class"
      glyphSize="inherit"
      organization={organization}
      isAdminView
      showChangeRole={canChangeRole}
      showCopyToClass={canCopyToAnotherGroup}
      showGetTranscript
      showBlockMember={canBlock}
      showRemoveFromSchool={canRemoveFromGroup}
      showReportAsAdmin={canReportToRemind}
      user={mapGraphQLMemberToUserActionsMenuButtonUser(member)}
      onUserRemoved={onUserRemoved}
      onUserUpdate={onUserUpdate}
      onGetTranscript={onGetTranscript}
      tooltip="More actions"
      tooltipPlacement="top"
    />
  );
}
